module.exports = __webpack_public_path__ + "img/fig14.4888f68f.jpg";